<div class="signature-wrapper">
  <canvas
      #canvas
      height="200"
      style="width: 100%; max-height: 400px; max-width: 400px"
      [style.pointer-events]="(isCanvasDisabled || formCtrl.disabled) ? 'none' : 'auto'"
      [style.border]="(isCanvasDisabled || formCtrl.disabled) ? '1px solid #c5c3c3' : '1px solid #000'"
      data-testid="signature-canvas"
  ></canvas>
  <div class="flex mrt-1 mrb-1 a-center justify-between">
    <button mat-stroked-button class="w-40" type="button" (click)="clearSignature()" [disabled]="formCtrl.disabled" data-testid="signature-clear-button">Очистить</button>
    <button type="button" mat-flat-button class="w-40" color="primary" [disabled]="formCtrl.disabled" (click)="saveSignature()" data-testid="signature-save-button">
      <mat-icon [style.color]="formCtrl.disabled ? 'gray' : 'none'">done</mat-icon>
    </button>
  </div>
</div>
